module.exports = __webpack_public_path__ + "static/media/commentIcon.37db4beb.svg";